const ArticleConstantService = {
  announcements: [
    "Breaking News: Major update in the tech world today!",
    "Latest: New advancements in AI technology announced.",
    "Hot Topic: Global markets see significant changes.",
  ],
  categories: [
    "General",
    "News",
    "Technology",
    "Business",
    "Entertainment",
    "Health",
    "Science",
    "Sports",
    "Politics",
  ],
  sources: [
    "CNET",
    "BBC News",
    "The Guardian",
    "Gizmodo.com",
    "IGN",
    "Vida Extra",
    "Livedoor.jp",
    "Biztoc.com",
    "Psychology Today",
    "Anime News Network",
    "IndieWire",
    "Atlas Obscura",
    "Pravda.com.ua",
    "Tumblr.com",
    "Haberturk.com",
    "Maximum-progress.com",
    "Antyweb.pl",
    "Eurogamer.es",
    "Filippo.io",
    "Zive.cz",
    "Lalibre.be",
    "Tvn24.pl",
    "Expresso.pt",
    "Minneapolis Star Tribune",
    "Globalsecurity.org",
    "ETF Daily News",
  ],
  authors: [
    "Justin Carter",
    "Ryan Dinsdale",
    "Juan Sanmartín",
    "nwknews",
    "theglobeandmail.com",
    "Marc Bekoff Ph.D.",
    "Alison Foreman",
    "ugc",
    "Sami Noponen",
    "Greg Hall",
    "Habertürk",
    "Maxwell Tabarrok",
    "Daniel Wójcik",
    "Josep Maria Sempere",
    "Filippo Valsorda",
    "Martin Chroust",
    "Belga Belga",
    "Meagan Navarro",
    "Maya Rao",
    "John Pike",
    "MarketBeat News",
    "Unknown",
    "Vlado Vince",
  ],
};

export default ArticleConstantService;
